module.exports = __webpack_public_path__ + "static/media/check-icon.5d1af7f6.svg";